import { useLoaderData } from "@remix-run/react";
import { loader as loaderPage } from "~/data/loaders/page";
import TemplatePageHome from "../templates/TemplatePageHome";
import TemplatePageTheMatesProgram from "../templates/TemplatePageTheMatesProgram";
import TemplatePageNotFound from "../templates/TemplatePageNotFound";
import TemplatePageResearch from "../templates/TemplatePageResearch";
import TemplatePageGetInvolved from "../templates/TemplatePageGetInvolved";
import TemplatePageContact from "../templates/TemplatePageContact";
import TemplatePageAbout from "../templates/TemplatePageAbout";
import TemplatePageFlexible from "../templates/TemplatePageFlexible";
import TemplateArchiveTeamLanding from "../templates/TemplateArchiveTeamLanding";
import TemplateArchiveResearchLibrary from "../templates/TemplateArchiveResearchLibrary";
import TemplatePageLanding from "../templates/TemplatePageLanding";
import { isTemplateType } from "~/sanity/types-mapped";
import TemplateArchiveIndustryPartners from "../templates/TemplateArchiveIndustryPartners";

type Props = {};

export default function RoutePage({}: Props) {
  const data = useLoaderData<typeof loaderPage>();

  const pageData = data?.page?.data;
  const template = pageData?.template;
  const form = data.form;
  const research = data.research;
  const members = data.members;
  const membersCarousel = data.membersCarousel;
  const partners = data.partners;
  const breadcrumbs = data.breadcrumbs;
  const industry = data.industry;
  const trainingStats = data.trainingStats;
  const featuredResearch = data.featuredResearch;

  // console.log(data);
  const TemplateDynamic = () => {
    if (isTemplateType(template, "templatePageHome")) {
      return (
        <TemplatePageHome
          data={{ ...template, trainingStats, featuredResearch }}
        />
      );
    } else if (isTemplateType(template, "templatePageTheMatesProgram")) {
      return (
        <TemplatePageTheMatesProgram data={{ ...template, breadcrumbs }} />
      );
    } else if (isTemplateType(template, "templatePageResearch")) {
      return (
        <TemplatePageResearch data={{ ...template, breadcrumbs }} />
      );
    } else if (isTemplateType(template, "templatePageGetInvolved")) {
      return (
        <TemplatePageGetInvolved
          data={{ ...template, form, breadcrumbs, industry }}
        />
      );
    } else if (isTemplateType(template, "templatePageContact")) {
      return <TemplatePageContact data={{ ...template, form }} />;
    } else if (isTemplateType(template, "templatePageAbout")) {
      return <TemplatePageAbout data={{ ...template, trainingStats }} />;
    } else if (isTemplateType(template, "templatePageFlexible")) {
      return <TemplatePageFlexible data={{ ...template, breadcrumbs }} />;
    } else if (isTemplateType(template, "templateArchiveTeamLanding")) {
      return (
        <TemplateArchiveTeamLanding
          data={{ ...template, breadcrumbs, members, membersCarousel }}
        />
      );
    } else if (isTemplateType(template, "templateArchiveResearchLibrary")) {
      return (
        <TemplateArchiveResearchLibrary
          data={{ ...template, research, breadcrumbs }}
        />
      );
    } else if (isTemplateType(template, "templatePageLanding")) {
      return <TemplatePageLanding data={{ ...template, form, breadcrumbs }} />;
    } else if (isTemplateType(template, "templateArchiveIndustryPartners")) {
      return (
        <TemplateArchiveIndustryPartners
          data={{ ...(template as object), breadcrumbs, partners }}
        />
      );
    } else if (isTemplateType(template, "templatePageNotFound")) {
      return <TemplatePageNotFound data={template} />;
    }
  };

  return TemplateDynamic();
}
